module.exports = __webpack_public_path__ + "img/logo.fcf2aa0c.png";